// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.api.web.landlord.v1.property.SatelliteWebLandlordPropertyHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  SatelliteWebLandlordPropertySearchRequestDto,
  SatelliteWebLandlordPropertySearchResponseDto,
} from '../..';

export const SatelliteWebLandlordPropertyHandler_search_Path = '/api/web/landlord/v1/property/search';

export const SatelliteWebLandlordPropertyHandler_search = (
  postData: SatelliteWebLandlordPropertySearchRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebLandlordPropertySearchRequestDto,
    SatelliteWebLandlordPropertySearchResponseDto
  >(
    {
      endpoint: SatelliteWebLandlordPropertyHandler_search_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};
